import { colors, fonts } from '@grupoboticario/flora-tokens/mooz/web/ds'

export const mooz = {
  colors,
  fonts,
}
